<template>
  <!--banner-->
  <div>
    <div class="container" style="height: 40px; line-height: 40px;color: #999">
      <i class="iconfont icon-ziyuan"></i>&nbsp;
      <span class="font_link_fw"><router-link to="/">首页</router-link></span>
      &nbsp;&nbsp;>&nbsp;&nbsp;
      <span>联系我们</span>
    </div>
    <div class="container" style=" margin-top: 30px; margin-bottom: 20px">
      <h1 class="post-title" style="margin-top:10px;">
        <span class="con">邮件联系</span>
      </h1>
    </div>
    <div class="container" style=" margin-top: 30px; margin-bottom: 20px">
      <div
        style="width:48%; display:inline-block;  margin-left: 10px; margin-right: 25px;"
      >
        <a class="ectbut" href="mailto:mfeihu@nxndvc.com">
          <span>联系我们</span>
          <br />
          mfeihu@nxndvc.com
        </a>
      </div>
      <div style="width:48%; display:inline-block;">
        <a class="ectbut" href="mailto:mfeihu@nxndvc.com">
          <span>加入我们</span>
          <br />
          mfeihu@nxndvc.com
        </a>
      </div>
    </div>
    <div class="container" style=" margin-top: 30px; margin-bottom: 20px">
      <h2 class="post-title" style="margin-top:10px;">
        <span class="con">联系方式</span>
      </h2>
    </div>
    <div class="container" style=" margin-top: 30px; margin-bottom: 20px">
      <p class="info">
        <img
          src="../../../assets/img/公司.png"
          alt="公司"
        />&nbsp;&nbsp;地址：宁夏宁东企业总部大楼
      </p>
      <p class="info">
        <img src="../../../assets/img/电话.png" alt="电话" /><a
          href="tel:057188851888"
          >&nbsp;&nbsp;电话：0951-5918508</a
        >
      </p>
      <p class="info">
        <img
          src="../../../assets/img/公司邮编.png"
          alt="公司邮编"
        />&nbsp;&nbsp;邮编：750409
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'contact'
}
</script>

<style scoped>
.font_link_fw a {
  color: #666;
}
.font_link_fw a:hover {
  color: #666;
}
.post-title {
  font-size: 26px;
  color: #666;
  padding-top: 10px;
  padding-right: 30px;
  padding-bottom: 0px;
  padding-left: 30px;
  margin-bottom: 20px;
  border-bottom-width: 1px;
  border-bottom-style: solid;
  border-bottom-color: rgb(234, 234, 234);
  text-align: left;
}
.con {
  display: inline-block;
  padding-bottom: 10px;
  margin-bottom: -1px;
  border-bottom-width: 1px;
  border-bottom-style: solid;
  border-bottom-color: rgb(0, 180, 237);
  font-weight: normal;
  color: #666;
}
.ectbut {
  margin-top: 10px;
  margin-right: 0px;
  margin-bottom: 10px;
  margin-left: 0px;
  padding-top: 30px;
  padding-right: 0px;
  padding-bottom: 30px;
  padding-left: 0px;
  display: block;
  border-top-color: rgb(255, 255, 255);
  border-top-style: solid;
  border-top-width: 1px;
  border-right-color: rgb(255, 255, 255);
  border-right-style: solid;
  border-right-width: 1px;
  border-bottom-color: rgb(255, 255, 255);
  border-bottom-style: solid;
  border-bottom-width: 1px;
  border-left-color: rgb(255, 255, 255);
  border-left-style: solid;
  border-left-width: 1px;
  font-size: 16px;
  background-color: #f4f4f4;
  text-align: center;
  border-top-left-radius: 6px;
  border-top-right-radius: 6px;
  border-bottom-left-radius: 6px;
  border-bottom-right-radius: 6px;
  color: #666 !important;
}
.ectbut:hover {
  background: rgb(0, 180, 237);
  color: #ffffff !important;
}
.info {
  padding-top: 15px;
  padding-right: 10px;
  padding-bottom: 15px;
  padding-left: 10px;
  margin-bottom: 0;
  color: #666;
  font-size: 14px;
  border-bottom-width: 1px;
  border-bottom-style: solid;
  border-bottom-color: rgb(234, 234, 234);
}
</style>
